import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { fetchVendorInfo, subscribeWithCoupon } from './store/slice/vendor/asyncThunks';
import { selectLoggedIn, setLoggedIn } from './store/slice/auth/slice';
import LoginPage from './screens/OnboardingPages/LoginPage/LoginPage';
import ForgotPasswordPage from './screens/OnboardingPages/ForgotPasswordPage/ForgotPasswordPage';
import SignupPage from './screens/OnboardingPages/SignupPage/SignupPage';
import RecoveryCodePage from './screens/OnboardingPages/RecoveryCodePage/RecoveryCodePage';
import ClientsPage from './screens/ClientsPage/ClientsPage';
import TemplatesPage from './screens/TemplatesPage/TemplatesPage';
import FAQPage from './screens/FAQPage/FAQPage';
import CalendarPage from './screens/CalendarPage/CalendarPage';
import InboxPage from './screens/InboxPage/InboxPage';
import NotificationsPage from './screens/NotificationsPage/NotificationsPage';
import ProfilePage from './screens/ProfilePage/ProfilePage';
import { GOOGLE_ANALYTICS_TRACKING_ID, LOCAL_STORAGE_ACCESS_TOKEN, SOCKET_EVENTS } from './utils/constants';
import './styles/index.css';
import './styles/responsive.css';
import AuthLayout from './layouts/AuthLayout';
import PrivateLayout from './layouts/PrivateLayout';
import {
  selectCloseSubscriptionModalDisabled,
  selectOpenSubscriptionModal,
  selectSubscribeWithCouponPending,
  selectUserInfo,
} from './store/slice/vendor/slice';
import socketService from './services/socketService';
import { addReceivedMessageToChatRoom, resetSelectedChatRoom } from './store/slice/chat/slice';
import GlobalStyles from './styles/globalStyles';
import { fetchNumOfUnreadNotifications } from './store/slice/notification/asyncThunks';
import { getAllChatRooms } from './store/slice/chat/asyncThunks';
import WeddingGuestPage from './screens/WeddingGuestPage/WeddingGuestPage';
import SplashScreen from './components/SplashScreen/SplashScreen';
import VerificationCodePage from './screens/OnboardingPages/VerificationCodePage/VerificationCodePage';
import InvitationsLayout from './layouts/InvitationsLayout';
import { loadStripe } from '@stripe/stripe-js';
import PaymentCardFormModal from './components/Modal/PaymentCardFormModal';
import SubscriptionModalComponent from './components/Modal/SubscriptionModalComponent';
import { StyledElements } from './screens/ProfilePage/ProfilePage.styles';
import ReactGA from 'react-ga';
import { notifyErrorLeft } from './utils/notify';
import DeleteAccountPage from './screens/ProfilePage/DeleteAccountPage';
export const stripe = await loadStripe(
  'pk_live_51O0SGwL5ivsNBx7OgwrQcPdNmmYuO98juW63kWrHatxu8O51eayT19akacrOH7Osrxugbopq7qnNdb8fhgSmckju00e7jwkBeD',
);

function App() {
  const dispatch = useDispatch();
  const vendor = useSelector(selectUserInfo);
  const isAuthenticated = useSelector(selectLoggedIn);
  const [minimumDurationPassed, setMinimumDurationPassed] = useState(false);
  const openSubscriptionModal = useSelector(selectOpenSubscriptionModal);

  const closeSubscriptionModalDisabled = useSelector(selectCloseSubscriptionModalDisabled);

  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);

  const subscribeWithCouponPending = useSelector(selectSubscribeWithCouponPending);

  ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);

  const location = useLocation();
  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  const handleSubscribe = () => {
    setSubscriptionModalOpen(false);
    setPaymentModalOpen(true);
  };

  const handleSubscribeWithPromoCode = code => {
    dispatch(subscribeWithCoupon({ code }))
      .unwrap()
      .then(() => {
        setSubscriptionModalOpen(false);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  useEffect(() => {
    if (openSubscriptionModal) {
      setSubscriptionModalOpen(true);
    }
  }, [openSubscriptionModal]);

  // useEffect(() => {
  //   const timer = setTimeout(() => setMinimumDurationPassed(true), 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    const timer = setTimeout(() => setMinimumDurationPassed(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
    if (token) {
      dispatch(fetchVendorInfo());
    } else {
      dispatch(setLoggedIn({ loggedIn: false }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (location.pathname !== '/inbox') {
      dispatch(resetSelectedChatRoom());
    }
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (isAuthenticated === true && vendor.name) {
      socketService.initializeSocket('vendor' + vendor.id);

      socketService.on(SOCKET_EVENTS.RECEIVE_MESSAGE, function (data, callback) {
        dispatch(addReceivedMessageToChatRoom({ ...data, id: vendor.id }));
        if (callback) {
          callback();
        }
      });

      dispatch(getAllChatRooms({ page: 1 }));
      let notificationInterval = setInterval(() => {
        dispatch(fetchNumOfUnreadNotifications());
      }, 30000);

      return () => {
        if (notificationInterval) {
          clearInterval(notificationInterval);
        }
      };
    }
  }, [dispatch, isAuthenticated, vendor.id, vendor.name]);

  return (
    <Fragment>
      <GlobalStyles />
      {isAuthenticated !== null && minimumDurationPassed ? (
        <>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            style={{ zIndex: 20000 }}
          />

          <Routes>
            <Route element={<AuthLayout />}>
              <Route path="/" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/sign-up" element={<SignupPage />} />
              <Route path="/recovery-code" element={<RecoveryCodePage />} />

              <Route path="/Verification-code" element={<VerificationCodePage />} />
            </Route>
            <Route element={<PrivateLayout />}>
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/delete-account" element={<DeleteAccountPage />} />
            </Route>

            <Route element={<InvitationsLayout />}>
              <Route path="/wedding-guest" element={<WeddingGuestPage />} />
            </Route>
          </Routes>
        </>
      ) : (
        <SplashScreen />
      )}

      <SubscriptionModalComponent
        width={'806px'}
        height={'500px'}
        closeDisabled={closeSubscriptionModalDisabled}
        modalOpen={subscriptionModalOpen}
        onCreate={handleSubscribe}
        subscribeWithPromoCode={handleSubscribeWithPromoCode}
        loading={subscribeWithCouponPending}
        onClose={() => {
          setSubscriptionModalOpen(false);
        }}
      />

      <StyledElements stripe={stripe}>
        <PaymentCardFormModal
          width={'620px'}
          height={'543px'}
          cancelDisabled={closeSubscriptionModalDisabled}
          modalOpen={paymentModalOpen}
          onClose={() => {
            setPaymentModalOpen(false);
          }}
          stripe={stripe}
        />
      </StyledElements>
    </Fragment>
  );
}

export default App;
